import React, { Component } from 'react';
import {
  addressDepthOne,
  addressDepthTwo,
  DISPLAY_STATUS,
} from '../../../library/postnumber/PostNumberConstants';
import SelectBox from './SelectBox';
import classNames from 'classnames';
import DesktopLayerPopup from '../DesktopLayerPopup';
import { RegExp } from '../../../library/constants/RegExp';
import { connect } from 'react-redux';
import * as PostNumberAction from '../../../library/postnumber/PostNumberAction';
import { KeyCode } from '../../../library/constants/KeyCode';

export class PostNumber extends Component {
  constructor(props) {
    super(props);
    this.searchKeyWordRef = React.createRef();

    this.state = {
      isRoadAddress: true,
      nAddressIndex: 0,
      nAddressStringSecond: '',
    };

    this.onClickClose = this.onClickClose.bind(this);
    this.onSelectAddressDepth1 = this.onSelectAddressDepth1.bind(this);
    this.onSelectAddressDepth2 = this.onSelectAddressDepth2.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.onClickAddress = this.onClickAddress.bind(this);
    this.props.initRoadAddress();
  }

  onClickTab(event, item) {
    event.preventDefault();
    if (item === 1) {
      this.initTab();
      this.setState({ isRoadAddress: true });
    } else {
      this.initTab();
      this.setState({ isRoadAddress: false });
    }
  }

  onClickClose() {
    this.props.onClose();
  }

  onSelectAddressDepth1(event) {
    this.setState({ nAddressIndex: event.data });
  }

  onSelectAddressDepth2(event) {
    this.setState({ nAddressStringSecond: event });
  }

  initTab() {
    this.searchKeyWordRef.value = '';
    this.props.initRoadAddress();
    this.setState({
      nAddressIndex: 0,
      nAddressStringSecond: '',
    });
  }

  onClickSearch(e) {
    if (e) {
      e.preventDefault();
    }
    this.goSearch();
  }

  goSearch() {
    let { isRoadAddress, nAddressIndex, nAddressStringSecond } = this.state;

    let searchKeyWord = this.searchKeyWordRef?.value ?? '';

    if (isRoadAddress) {
      if (nAddressIndex === 0) {
        DesktopLayerPopup.notice({ message: '시·도를 선택해주세요.' });
        return;
      } else if (nAddressStringSecond === '') {
        DesktopLayerPopup.notice({ message: '시·군·구를 선택해주세요.' });
        return;
      }
    }

    if (searchKeyWord.trim().length === 0) {
      DesktopLayerPopup.notice({ message: '검색어를 입력해주세요.' });
      return;
    }

    if (!isRoadAddress) {
      if (searchKeyWord.trim().length < 3) {
        DesktopLayerPopup.notice({
          message: '검색어를 3자 이상으로 입력해주세요.',
        });
        return;
      }
    }

    if (RegExp.ONLY_KOREAN_NUMBER.test(searchKeyWord) === false) {
      this.searchKeyWordRef?.blur();
      DesktopLayerPopup.notice({
        message: '검색어는 한글과 숫자만 입력해주세요.',
      });
      return;
    }

    if (isRoadAddress) {
      this.props.getRoadAddress(
        addressDepthOne[nAddressIndex - 1].label +
          ' ' +
          nAddressStringSecond +
          ' ' +
          searchKeyWord
      );
    } else {
      this.props.getRoadAddress(searchKeyWord);
    }
  }

  onClickAddress(e, data) {
    e.preventDefault();
    if (this.props.onSelect) {
      this.props.onSelect(data);
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }

  getSelectBoxRenderer = () => {
    let { isRoadAddress, nAddressIndex } = this.state;
    if (isRoadAddress) {
      return (
        <span>
          <SelectBox
            labels={addressDepthOne}
            defaultSelected={'시·도 선택'}
            onSelected={this.onSelectAddressDepth1}
            size="7"
          />
          <SelectBox
            labels={addressDepthTwo[nAddressIndex]}
            defaultSelected={'시·군·구 선택'}
            onSelected={this.onSelectAddressDepth2}
            size="7"
          />
        </span>
      );
    } else {
      return <span></span>;
    }
  };

  getAddressListRenderer = () => {
    const { addressState, addressData } = this.props;
    let { isRoadAddress } = this.state;
    let addressList;
    let addressListContent;

    if (addressState === DISPLAY_STATUS.displayStatusInit) {
      return null;
    } else if (addressState === DISPLAY_STATUS.displayStatusDisplayingList) {
      addressListContent = addressData.map((data, index) => {
        const newData = {
          ...data,
          zip: data.postcode5,
          addr:
            data.ko_common + ' ' + data.ko_doro + ' (' + data.ko_jibeon + ')',
        };
        return (
          <tr
            onClick={(e) => {
              this.onClickAddress(e, newData);
            }}
            key={index}
          >
            <td>{newData.zip}</td>
            <td>{newData.addr}</td>
          </tr>
        );
      });
      addressList = (
        <table>
          <tbody>{addressListContent}</tbody>
        </table>
      );
    } else if (addressState === DISPLAY_STATUS.displayStatusNoList) {
      if (isRoadAddress) {
        return (
          <p>
            검색 결과가 없습니다.
            <br />
            도로명을 다시 입력해 주세요.
          </p>
        );
      } else {
        return (
          <p>
            검색 결과가 없습니다.
            <br />
            동(읍/면) 명을 다시 입력해 주세요.
          </p>
        );
      }
    }
    return addressList;
  };

  onPasswordKeyDown = (e) => {
    if (e.keyCode === KeyCode.ENTER) {
      this.setState(
        {
          password: e.target.value,
        },
        () => {
          this.onClickSearch();
        }
      );

      e.preventDefault();
      return false;
    }
  };

  componentWillUnmount() {
    this.props.initRoadAddress();
  }

  render() {
    let { isRoadAddress } = this.state;
    const { addressState } = this.props;

    return (
      <div
        className="layer-wrap large"
        style={{ marginTop: -280, overflow: 'visible' }}
      >
        <div className="layer-post">
          <h2 className="line">우편번호 찾기</h2>
          <ul className="tab-type cell-2">
            <li
              onClick={(e) => this.onClickTab(e, 1)}
              className={classNames({ on: isRoadAddress === true })}
            >
              <a href="#">도로명 주소</a>
            </li>
            <li
              onClick={(e) => this.onClickTab(e, 2)}
              className={classNames({ on: isRoadAddress === false })}
            >
              <a href="#">지번 주소</a>
            </li>
          </ul>

          <fieldset className="post">
            <legend>우편번호 검색</legend>
            {/*INLINE_STYLE*/}
            <p style={{ clear: 'both' }}>
              {isRoadAddress
                ? '찾으실 도로명 주소를 상세하게 입력해주세요.'
                : '찾으실 동/읍/면을 입력해 주세요.'}
              <br />
              <b>
                {isRoadAddress
                  ? '예) 강남구 역삼로1, 수지구 죽전로 2'
                  : '예) 대치동, 청담동'}
              </b>
            </p>

            {this.getSelectBoxRenderer()}
            {/*INLINE_STYLE*/}
            <input
              type="text"
              name=""
              style={{ imeMode: 'inactive' }}
              ref={(ref) => (this.searchKeyWordRef = ref)}
              title=""
              placeholder={
                isRoadAddress
                  ? '이하 상세주소 입력(도로명, 건물번호)'
                  : '동/읍/면 입력'
              }
              onKeyDown={this.onPasswordKeyDown}
            />
            <button onClick={this.onClickSearch} className="btn-type">
              <i>검색</i>
            </button>
          </fieldset>

          <div
            className={classNames(
              'scroll-list',
              {
                road:
                  addressState === DISPLAY_STATUS.displayStatusDisplayingList &&
                  isRoadAddress === true,
              },
              {
                number:
                  addressState === DISPLAY_STATUS.displayStatusDisplayingList &&
                  isRoadAddress === false,
              },
              {
                none:
                  addressState !== DISPLAY_STATUS.displayStatusDisplayingList,
              }
            )}
          >
            {this.getAddressListRenderer()}
          </div>
        </div>
        <button className="close" onClick={this.onClickClose}>
          팝업 닫기
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    addressState: state.PostNumberReducer.addressState,
    addressData: state.PostNumberReducer.addressData,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getRoadAddress: (query) => {
      dispatch(PostNumberAction.getRoadAddress(query));
    },
    initRoadAddress: () => {
      dispatch(PostNumberAction.initRoadAddress());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PostNumber);
